function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B8C8CC",
  fillRule: "evenodd",
  d: "M14.616 2.363c.512.485.512 1.278 0 1.762l-1.97 1.9C16.762 6.356 20 9.8 20 14c0 4.418-3.582 8-8 8s-8-3.582-8-8c0-.67.543-1.212 1.212-1.212.67 0 1.212.543 1.212 1.212 0 3.08 2.497 5.576 5.576 5.576 3.08 0 5.576-2.497 5.576-5.576 0-3.07-2.48-5.56-5.546-5.576l2.586 2.45c.482.457.51 1.186.085 1.674l-.085.089c-.482.456-1.252.482-1.768.08l-.093-.08-2.792-2.643-1.477-1.391-.1-.103c-.515-.578-.515-1.427 0-2.005l.096-.099.695-.658.786-.732 2.792-2.643c.512-.484 1.35-.484 1.861 0z"
});

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.03018eca.svg";
export { ForwardRef as ReactComponent };